/**
 * Common printing utility for medical receipts
 */

const receiptStyles = `
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; }
    .header { text-align: center; margin-bottom: 30px; }
    .header h1 { margin: 0; font-size: 28px; text-transform: uppercase; }
    .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 20px; }
    .info-item { font-size: 14px; margin: 4px 0; }
    table { width: 100%; border-collapse: collapse; margin: 20px 0; }
    th { background-color: #f2f2f2; border: 1px solid #ddd; padding: 12px; text-align: left; }
    td { border: 1px solid #ddd; padding: 12px; }
    .text-right { text-align: right; }
    .footer-totals { margin-top: 20px; border-top: 2px solid #333; padding-top: 10px; }
    .summary-row { display: flex; justify-content: space-between; font-weight: bold; margin: 5px 0; }
    @media print { .no-print { display: none; } }
  </style>
`;

export const executeBrowserPrint = (htmlContent) => {
  const printWindow = window.open("", "PRINT", "height=800,width=1000");
  printWindow.document.write(`
    <html>
      <head>
        <title>Bill Receipt</title>
        ${receiptStyles}
      </head>
      <style>
            body { font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; color: #333; }
            .header { text-align: center; margin-bottom: 20px; }
            .clinic-name { font-size: 24px; font-weight: 500; letter-spacing: 1px; margin-bottom: 5px; text-transform: uppercase; }
            .clinic-details { font-size: 12px; margin: 2px 0; color: #444; }
            
            .info-section { border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 10px 0; margin: 15px 0; }
            .info-row { display: flex; justify-content: space-between; margin-bottom: 4px; }
            .info-col { display: flex; width: 48%; font-size: 13px; }
            .label { font-weight: bold; width: 110px; }
            
            .bill-meta { font-size: 13px; margin: 10px 0; }
            
            table { width: 100%; border-collapse: collapse; font-size: 13px; margin-bottom: 5px; }
            th { background-color: #e0e0e0 !important; -webkit-print-color-adjust: exact; text-align: left; padding: 8px; font-weight: bold; }
            td { padding: 8px; border-bottom: 1px solid #eee; }
            .text-right { text-align: right; }
            
            .total-row { text-align: right; font-weight: bold; padding: 10px 0; font-size: 13px; border-bottom: 1px solid #eee; }
            .footer-summary { display: flex; justify-content: space-between; margin-top: 15px; font-weight: bold; font-size: 13px; }
            
            @media print { 
               body { padding: 0; }
               th { background-color: #e0e0e0 !important; -webkit-print-color-adjust: exact; }
            }
          </style>
      <body>
        ${htmlContent}
        <script>
          window.onload = function() {
            window.focus();
            window.print();
            window.close();
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};

export const getPrintTemplateContent = (ref) => {
  return ref?.current?.innerHTML || "";
};